import React, { useMemo } from "react";
import isEqual from "react-fast-compare";
import Widget from "../../../components/layout2/sectionInsight/Widget";

// Accepts widgets array and columnSpan (or use widget.span if present)
const SectionWidgetContainer = ({
  widgets = [],
  section_index = 0,
  section_id = null,
  sections = [],
  columnSpan = "full",
  ...rest
}) => {
  const widgetList = useMemo(() => {
    if (widgets && Array.isArray(widgets)) {
      return [...widgets];
    }
    return [];
  }, [widgets]);
  return (
    <div className="row ml-0">
      {Array.isArray(widgetList) &&
        widgetList.map((widget, widget_index) => {
          // Use widget.span if present, else fallback to columnSpan prop
          const span = widget.span || columnSpan;

          // Determine column class based on span
          let colClass = "col-12";
          if (span === "half") colClass = "col-12 col-md-6";
          if (span === "third") colClass = "col-12 col-md-4";
          // Add more as needed

          return (
            <Widget
              {...rest}
              key={section_id + widget?.widget_id + widget_index}
              data={widget}
              section_index={section_index}
              widget_index={widget_index}
              widget_graph_type={widget?.graph_type}
              section_id={section_id}
              sections={sections}
              widget_id={widget?.widget_id}
              nextWidgetdata={widgetList[widget_index + 1]}
              prevWidgetdata={widgetList[widget_index - 1]}
              columnSpan={span}
              isDeepdiveDashboardView={true}
            />
          );
        })}
    </div>
  );
};

export default React.memo(SectionWidgetContainer, isEqual);
